module.exports = __webpack_public_path__ + "static/img/invest-make5.39cf616.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-make5.jpg
// module id = Z5Cp
// module chunks = 0